import { useState, Fragment, useEffect, useCallback, ClassAttributes, InputHTMLAttributes } from "react";
import InputMask from "react-input-mask";
import { Grid, Button } from "@mui/material";

import "./ksopBeneficiaryName.css";
import { KSOPBeneficieryNameProps } from "../../../../../../../types/components/enrollmentProps.types";

const KsopBeneficiaryName = ({
	primaryBeneficiery,
	contingentBeneficiery,
	setPrimaryBeneficiery,
	setContingentBeneficiery
}: KSOPBeneficieryNameProps): JSX.Element => {
	// const _dateMask = /(0[1-9]|1[0-9]|2[0-9]|3[01])/;
	// const _monthMask = /(0[1-9]|1[012])/;
	// const _yearMask = /([19]{2})?([1-9]{2})/;
	// const _dobMask = [_dateMask, _monthMask, _yearMask];
	const handleBeneficiaryDetailsChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>, id: number, option: "Primary" | "Contingent", index: number) => {
			const { name, value } = event.target;
			// console.log(index);
			// console.log(name);
			if (name === "date_of_birth") {
				const _value = value.split("/");
				// console.log("Value", _value);
				if (_value.length === 2 && !_value[1]) {
					if (parseInt(value) > 12) {
						alert("Invalid month. Valid format mm/dd/yyyy");
						event.target.value = "";
						return;
					}
				} else if (_value.length === 3 && _value[1] !== "") {
					// console.log(parseInt(value));
					if (
						(parseInt(_value[1]) > 31 && parseInt(_value[0]) % 2 !== 0) ||
						(parseInt(_value[1]) > 31 && parseInt(_value[0]) % 2 === 0)
					) {
						alert("Invalid date. Valid format mm/dd/yyyy");
						event.target.value = _value[0];
						return;
					}
				}
			}
			if (name === "address" && value.length > 20) {
				// event.target.value = "";
				return;
			}
			if (option === "Primary") {
				if (primaryBeneficiery[index].id === id) {
					const _primaryBeneficiery = primaryBeneficiery;
					_primaryBeneficiery[index] = Object.assign({}, primaryBeneficiery[index], { [name]: value });
					setPrimaryBeneficiery(Object.assign([], _primaryBeneficiery));
				}
			}

			if (option === "Contingent") {
				if (contingentBeneficiery[index].id === id) {
					const _contingentBeneficiery = contingentBeneficiery;
					_contingentBeneficiery[index] = Object.assign({}, contingentBeneficiery[index], {
						[name]: value
					});

					setContingentBeneficiery(Object.assign([], _contingentBeneficiery));
				}
			}
		},
		[contingentBeneficiery, primaryBeneficiery, setContingentBeneficiery, setPrimaryBeneficiery]
	);

	// console.log("Primary ", primaryBeneficiery);
	// console.log("Contingent", contingentBeneficiery);

	return (
		<>
			<div className="ksop-block">
				<div className="side-box">MUST COMPLETE BENEFICIARY DESIGNATION</div>
				<div className="content-box-gray">
					<div className="title">BENEFICIARY NAME (S)</div>

					<div className="content" style={{ fontSize: "15px" }}>
						<b style={{ fontSize: "14px" }}>
							Before completing, please read the information on the back of this form for direction and
							examples.
						</b>
						<p style={{ fontSize: "14px" }}>
							<b>Note :</b> Unless otherwise provided, if two or more beneficiaries are named, the
							proceeds shall be paid to the named beneficiaries, or to the survivor or survivors, in equal
							shares.
						</p>
						<Grid container spacing={0}>
							<Grid item xs={3}>
								Name<mark>[Primary Beneficary(S)]</mark>
							</Grid>
							<Grid item xs={1}>
								Date Of Birth
							</Grid>
							<Grid item xs={2}>
								Relationship
							</Grid>
							<Grid item xs={2}>
								Soc. Sec. No.
							</Grid>
							<Grid item xs={3}>
								Address
							</Grid>
							<Grid item xs={1}>
								Percent
							</Grid>
						</Grid>
						{primaryBeneficiery.map((value, index) => {
							const { id, address } = value;
							// console.log("value", value);
							return (
								<div key={index}>
									<Grid container spacing={0}>
										<Grid item xs={3}>
											<input
												className="input-without-border"
												name="name"
												size={60}
												maxLength={30}
												type="text"
												placeholder="Name"
												onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
													handleBeneficiaryDetailsChange(event, id, "Primary", index)
												}
											></input>
										</Grid>
										<Grid item xs={1}>
											<InputMask
												mask="99/99/9999"
												maskChar=""
												disabled={false}
												onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
													handleBeneficiaryDetailsChange(event, id, "Primary", index)
												}
											>
												{() => (
													<input
														className="input-without-border"
														name="date_of_birth"
														type="text"
														placeholder="MM/DD/YYYY"

														// onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
														// 	handleBeneficiaryDetailsChange(event, value.id, "Primary", index)
														// }
													></input>
												)}
											</InputMask>
										</Grid>
										<Grid item xs={2}>
											<input
												className="input-without-border"
												name="relationship"
												type="text"
												placeholder="Relationship"
												onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
													handleBeneficiaryDetailsChange(event, id, "Primary", index)
												}
											></input>
										</Grid>
										<Grid item xs={2}>
											<InputMask
												mask="999-99-9999"
												maskChar=""
												disabled={false}
												onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
													handleBeneficiaryDetailsChange(event, id, "Primary", index)
												}
											>
												{() => (
													<input
														className="input-without-border"
														name="SSN"
														type="text"
														placeholder="XXX-XX-XXXX"
														maxLength={11}

														// onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
														// 	handleBeneficiaryDetailsChange(
														// 		event,
														// 		value.id,
														// 		"Primary",
														// 		index
														// 	)
														// }
													/>
												)}
											</InputMask>
										</Grid>
										<Grid item xs={3}>
											<input
												className="input-without-border"
												type="text"
												size={80}
												maxLength={20}
												value={address}
												// size="80"
												//maxLength={35}
												name="address"
												placeholder="Address"
												onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
													handleBeneficiaryDetailsChange(event, id, "Primary", index)
												}
											></input>
										</Grid>
										<Grid item xs={1}>
											<input
												className="input-without-border"
												type="text"
												name="percentage"
												placeholder="Percent"
												onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
													handleBeneficiaryDetailsChange(event, id, "Primary", index)
												}
											></input>
										</Grid>
									</Grid>
									<hr></hr>
								</div>
							);
						})}
						<p>If Primary Beneficiary is not living, pay death benefits to:</p>
						<Grid container spacing={0}>
							<Grid item xs={3}>
								Name<mark>[Contingent Beneficary(S)]</mark>
							</Grid>
							<Grid item xs={1}>
								Date Of Birth
							</Grid>
							<Grid item xs={2}>
								Relationship
							</Grid>
							<Grid item xs={2}>
								Soc. Sec. No.
							</Grid>
							<Grid item xs={3}>
								Address
							</Grid>
							<Grid item xs={1}>
								Percent
							</Grid>
						</Grid>
						{contingentBeneficiery.map((value, index) => {
							return (
								<div key={index}>
									<Grid container spacing={0}>
										<Grid item xs={3}>
											<input
												className="input-without-border"
												name="name"
												// size="60"
												type="text"
												placeholder="Name"
												onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
													handleBeneficiaryDetailsChange(event, value.id, "Contingent", index)
												}
											></input>
										</Grid>
										<Grid item xs={1}>
											<InputMask
												mask="99/99/9999"
												maskChar=""
												disabled={false}
												onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
													handleBeneficiaryDetailsChange(event, value.id, "Contingent", index)
												}
											>
												{() => (
													<input
														className="input-without-border"
														name="date_of_birth"
														type="text"
														placeholder="MM/DD/YYYY"
														// onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
														// 	handleBeneficiaryDetailsChange(event, value.id, "Primary", index)
														// }
													></input>
												)}
											</InputMask>
										</Grid>
										{/* <Grid item xs={1}>
											<input
												className="input-without-border"
												name="date_of_birth"
												type="text"
												placeholder="MM/DD/YYYY"
												onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
													handleBeneficiaryDetailsChange(event, value.id, "Contingent", index)
												}
											></input>
										</Grid> */}
										<Grid item xs={2}>
											<input
												className="input-without-border"
												name="relationship"
												type="text"
												placeholder="Relationship"
												onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
													handleBeneficiaryDetailsChange(event, value.id, "Contingent", index)
												}
											></input>
										</Grid>
										<Grid item xs={2}>
											<InputMask
												mask="999-99-9999"
												maskChar=""
												disabled={false}
												onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
													handleBeneficiaryDetailsChange(event, value.id, "Contingent", index)
												}
											>
												{() => (
													<input
														className="input-without-border"
														name="SSN"
														type="text"
														placeholder="XXX-XX-XXXX"
														maxLength={11}

														// onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
														// 	handleBeneficiaryDetailsChange(
														// 		event,
														// 		value.id,
														// 		"Primary",
														// 		index
														// 	)
														// }
													/>
												)}
											</InputMask>
										</Grid>
										{/* <Grid item xs={2}>
											<input
												className="input-without-border"
												name="SSN"
												type="text"
												placeholder="XXX-XX-XXXX"
												onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
													handleBeneficiaryDetailsChange(event, value.id, "Contingent", index)
												}
											></input>
										</Grid> */}
										<Grid item xs={3}>
											<input
												className="input-without-border"
												// size="80"
												type="text"
												name="address"
												value={value.address}
												placeholder="Address"
												onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
													handleBeneficiaryDetailsChange(event, value.id, "Contingent", index)
												}
											></input>
										</Grid>
										<Grid item xs={1}>
											<input
												className="input-without-border"
												type="text"
												name="percentage"
												placeholder="Percent"
												onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
													handleBeneficiaryDetailsChange(event, value.id, "Contingent", index)
												}
											></input>
										</Grid>
									</Grid>
									<hr></hr>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</>
	);
};
export default KsopBeneficiaryName;
